import objectFitImages from 'object-fit-images';
import DOMHelper from './utils/DOMHelper';
import store from './store/store';
// eslint-disable-next-line no-unused-vars
import { App } from './pages/app';
import './index.css';
import Initializer from './initializer';
import registerServiceWorker from './registerServiceWorker';
import { ErrorHandler } from './utils';
import { LocalStorage } from 'utils';
import { getApp, getNavigation } from './pages/app/appActions';
import { fetchFilters } from './features/CountyFilter/countyFilterActions';
import { scrollToId } from './utils/scroll';
import { fixSafariNavWidth } from './features/Navigation/navigationDropdownWidthFix';
import { initNavigationDropdownWidthFix } from './features/Navigation/navigationDropdownWidthFix';

const Storage = new LocalStorage();

Storage.setVersion(process.env.VERSION);

store.dispatch(getApp());
store.dispatch(getNavigation());
store.dispatch(fetchFilters());

console.log(`FE-V: ${process.env.VERSION}`);
function markUiReady() {
  // Add a class to the root element to indicate that the UI is ready.
  // This can be used to trigger CSS transitions or other effects that should only occur after the initial render is complete.
  document.documentElement.classList.add('ui-ready');
}

if (!DOMHelper.inEpiEditMode()) {
  Initializer.setupRavenLogger();
  Initializer.renderApp(store);
  registerServiceWorker();
  // Mark UI as ready after the first paint to ensure that the critical CSS has been applied and the page is visually complete
  if (window.requestAnimationFrame) {
    window.requestAnimationFrame(function() {
      markUiReady();
    });
  } else {
    // Fallback for browsers that do not support requestAnimationFrame
    setTimeout(markUiReady, 0);
  }
} else if (document.getElementById('root-edit-mode')) {
  Initializer.renderEditModeApp(store);
  Initializer.renderBlockPreview(store);
  markUiReady();
}

if (!DOMHelper.inEpiEditMode()) {
  Initializer.setupRavenLogger();
  Initializer.renderApp(store);
  registerServiceWorker();
} else if (document.getElementById('root-edit-mode')) {
  Initializer.renderEditModeApp(store);
  Initializer.renderBlockPreview(store);
}

window.addEventListener(
  'load',
  function() {
    objectFitImages(null, { watchMQ: true });

    if (ErrorHandler.DebugEnabled()) {
      console.log('LOGS ENABLED');
    }
  },

  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[data-scroll-target]');
    if (!link) return;
    var id = link.getAttribute('data-scroll-target');
    var el = document.getElementById(id);
    if (!el) return;

    e.preventDefault();
    scrollToId(id);
  })
);

window.addEventListener('resize', fixSafariNavWidth);

document.addEventListener('click', function(event) {
  var toggle = event.target.closest('[data-nav-toggle]');
  if (!toggle) return;

  var item = toggle.closest('.main-nav__item');
  if (!item) return;

  var isOpen = item.classList.toggle('is-open');
  toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  fixSafariNavWidth();
});

initNavigationDropdownWidthFix();
